export function teamSlider() {
    let $slider = $('.team-list.desk');

    function sliderInit() {
        $slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" style=""><svg width="30" height="13" viewBox="0 0 30 13" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M29.5 6.44238L4.5 6.44238V6.41113L29.5 6.41113V6.44238Z" fill="#2D2D2D" stroke="#2D2D2D"/>\n' +
            '<path d="M5.5 10.2899L0.788441 6.42554L5.5 2.56121L5.5 10.2899Z" fill="#2D2D2D" stroke="#2D2D2D"/>\n' +
            '</svg></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg width="30" height="12" viewBox="0 0 30 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M0.5 5.98242H25.5V6.01807H0.5V5.98242Z" fill="#2D2D2D" stroke="#2D2D2D"/>\n' +
            '<path d="M24.5 2.13415L29.2116 5.99902L24.5 9.8639L24.5 2.13415Z" fill="#2D2D2D" stroke="#2D2D2D"/>\n' +
            '</svg></button >',
            responsive: [{
                breakpoint: 1199,
                settings: 'unslick'
            }]
        });
    }

    $(window).on('load resize', function () {
        if (window.innerWidth > 1199 && !$slider.hasClass('slick-initialized')) {
            sliderInit();
        }
    });

    let showMoreBtn = $('.team .show-more .button');

    let $list = $('.team-list.mob');
    showMoreBtn.on('click', function (e) {
        e.preventDefault();

        let $this = $(this);
        let $paged = parseInt($this.attr('data-paged'));
        let $max_pages = parseInt($this.attr('data-max-pages'));

        $paged++;

        let data = {
            'action': 'load_team',
            'paged': $paged
        };

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: data,
            type: 'POST',
            beforeSend: function () {
                $this.text('Loading...').addClass('disable-links');
            },
            success: function (response) {
                if (response) {
                    $list.append(response);
                    $this.attr('data-paged', $paged);

                    if ($paged === $max_pages) {
                        $this.hide();
                    }
                }
            },
            complete: function () {
                $this.text('Load More').removeClass('disable-links');
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/teamSlider.js